import React from 'react';
import {Card, Col, Container, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faShieldHalved, faFingerprint, faLock, faServer, faCircleInfo
} from '@fortawesome/free-solid-svg-icons';

const summaryCards = [
    {
        icon: faShieldHalved,
        accentClass: 'accent-primary',
        metric: 'Zero',
        title: 'No made-up answers',
        desc: 'Every answer is traced to a real document. If the answer isn\'t in the source, the system says so — it doesn\'t invent one.'
    },
    {
        icon: faFingerprint,
        accentClass: 'accent-secondary',
        metric: 'Same answer',
        title: 'Consistent, every time',
        desc: 'Ask the same question today, tomorrow, next quarter — you get the same answer. No drift. No surprises in an audit.'
    },
    {
        icon: faLock,
        accentClass: 'accent-primary-dark',
        metric: 'Your data, your site',
        title: 'UK data sovereignty',
        desc: 'Runs entirely on your infrastructure or a UK-based environment of your choice. Nothing leaves your control, ever.'
    },
    {
        icon: faServer,
        accentClass: 'accent-accent',
        metric: '< 1 GB',
        title: 'Runs on a laptop',
        desc: 'Small enough to deploy anywhere — on-premise, in a secure cloud, or on a clinician\'s device. No data-centre dependency.'
    }
];

const TestingSummarySection = () => (
    <section className="testing-summary-section">
        <Container>
            <div className="text-center mb-4">
                <div className="section-label">Why You Can Trust It</div>
                <h2>The four things that matter for regulated AI.</h2>
                <p className="section-intro">
                    Most AI fails in regulated industries on the same four counts —
                    it makes things up, it changes its mind, it ships your data
                    somewhere, and it costs a fortune to run. Here's how we hold
                    on each one.
                </p>
            </div>

            <Row className="g-4 mb-4">
                {summaryCards.map((c, i) => (
                    <Col key={i} md={6} lg={3}>
                        <Card className={`problem-card testing-card h-100 ${c.accentClass}`}>
                            <div className="problem-card-accent testing-card-accent"/>
                            <Card.Body className="p-4">
                                <div className="problem-icon-ring testing-card-icon">
                                    <FontAwesomeIcon icon={c.icon}/>
                                </div>
                                <div className="testing-card-metric">{c.metric}</div>
                                <h3 className="problem-title">{c.title}</h3>
                                <p className="problem-desc">{c.desc}</p>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            <div className="testing-disclaimer mx-auto">
                <div className="d-flex align-items-start gap-3">
                    <FontAwesomeIcon icon={faCircleInfo} className="testing-disclaimer-icon"/>
                    <div>
                        <p className="testing-disclaimer-text">
                            <strong>Every release is tested.</strong>{' '}
                            We measure consistency, accuracy, response time, and behaviour
                            under load on every build before it leaves our lab. Customer-specific
                            testing happens with you, on your data, during a pilot.
                            Detailed test reports available on request.
                        </p>
                    </div>
                </div>
            </div>
        </Container>
    </section>
);

export default TestingSummarySection;